import { render, staticRenderFns } from "./DataPlans.vue?vue&type=template&id=c59a767c&scoped=true&"
import script from "./DataPlans.vue?vue&type=script&lang=js&"
export * from "./DataPlans.vue?vue&type=script&lang=js&"
import style0 from "./DataPlans.vue?vue&type=style&index=0&id=c59a767c&lang=scss&scoped=true&"
import style1 from "./DataPlans.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c59a767c",
  null
  
)

export default component.exports